import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuPlanParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: MenuPlanParamsState = {
  params: null,
};

const initiateMenuProjectionDashboardSliceParams = createSlice({
  name: 'initiateMenuProjectionDashboardSliceParams',
  initialState,
  reducers: {
    setMenuProjectionDashboardParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setMenuProjectionDashboardParams } = initiateMenuProjectionDashboardSliceParams.actions;

export default initiateMenuProjectionDashboardSliceParams.reducer;
